import { SWATCH } from './section-form'

export type SwatchMove = 'earlier' | 'later'

/**
 * Order is not cosmetic here: a `count` ladder unlocks swatches by POSITION, so moving one changes
 * which tier gets it.
 */
export function moveSwatch(
  swatches: string[],
  index: number,
  direction: SwatchMove,
): string[] {
  const to = direction === 'earlier' ? index - 1 : index + 1
  if (index < 0 || index >= swatches.length || to < 0 || to >= swatches.length) {
    return swatches
  }
  const next = [...swatches]
  const [lifted] = next.splice(index, 1)
  next.splice(to, 0, lifted)

  return next
}

export type SwatchAddResult =
  | { ok: true; swatches: string[] }
  | { ok: false; reason: 'invalid' | 'duplicate' }

/**
 * A duplicate is refused rather than appended: `perSlug` is keyed BY hex, so two identical swatches
 * cannot be given different tiers and the second one would be dead weight.
 */
export function addSwatch(swatches: string[], raw: string): SwatchAddResult {
  const hex = raw.trim().replace(/^#/, '').toUpperCase()
  if (!SWATCH.test(hex)) {
    return { ok: false, reason: 'invalid' }
  }
  if (swatches.some((s) => s.toUpperCase() === hex)) {
    return { ok: false, reason: 'duplicate' }
  }

  return { ok: true, swatches: [...swatches, hex] }
}

export const removeSwatch = (swatches: string[], index: number): string[] =>
  swatches.filter((_s, i) => i !== index)

/** `#RRGGBB` for `<input type="color">`, which refuses a bare hex. */
export const toPickerValue = (hex: string): string =>
  SWATCH.test(hex) ? `#${hex.toUpperCase()}` : '#000000'

export const fromPickerValue = (value: string): string =>
  value.replace(/^#/, '').toUpperCase()
